import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import campaignsReducer from '../features/campaigns/campaignsSlice';
import filtersReducer from '../features/filters/FiltersSlice'
import sidebarReducer from '../features/sidebar/SidebarSlice';
import usersReducer from '../features/users/UsersSlice';

export const store = configureStore({
  reducer: {
    campaigns: campaignsReducer,
    users: usersReducer,
    sidebar: sidebarReducer,
    filters: filtersReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
